import Axios from 'axios';
import { IAxiosParams } from '@/models/axios';
import { Toast } from '@lux/sharp-ui-next';
import { isInKwai } from '@/utils/device';
import { invoke } from '@yoda/bridge';
import { RADAR_EVENT } from '@/utils/logs/settleLog';

const createAxios = (params?: IAxiosParams) => {
  const axios = Axios.create({
    timeout: 10 * 1000,
    baseURL: params?.baseURL || '/',
  });

  axios.interceptors.response.use(
    // 请求成功 response 网络层对象
    async (response) => {
      // 请求后操作，如：关闭loading等
      const result = response?.data?.result;
      if (
        isInKwai &&
        (result === 109 ||
          result === 6001 ||
          result === 6002 ||
          result === -401)
      ) {
        Toast.error('当前登录失效，请退出后重新登录');
        RADAR_EVENT('coupon-mp-new-h5-settle-login', {
          extra_info: {
            params: {
              result,
            },
          },
        });
        setTimeout(() => {
          invoke('social.logout');
        }, 1500);
      }
      return Promise.resolve(response);
    },
    // 请求失败
    async (error) => {
      const { response } = error;
      if (response) {
        // 已发送请求，但接口报错，状态码不为2xx在这里处理
        // 状态码不为2xx的直接toast错误信息
        const errMessage = response.data.message;
        Toast.error(errMessage || '请求失败');
        return Promise.reject(error);
      }
      // 断网或未建立链接在这里处理
      return Promise.reject(error);
    }
  );
  return axios;
};

export default createAxios;
